



























import Vue from "vue";
export default Vue.extend({
  name: "ehr-button",
  props: {
    buttonTypeClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    isDuotone: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {};
  },
});
